import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import {
  convertPrice,
  getCountry,
  uaeString,
} from '../../../Utils/ForeignUtils';
import { removeDefaultParams } from '../../../Utils/helper';
import {
  Discount,
  ProductPrice,
  StrikePrice,
  TotalAmount,
} from '../ProductDetail/styled';
import {
  ComboCard,
  ComboCardContainer,
  ProductName,
  SaveSticker,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function SaveComboCard({ productData, comboData, userType }) {
  const router = useRouter();
  const userTypeA = true;
  const [country, setCountry] = useState();
  const cardClickHandler = (data) => {
    const pricingParam =
      data?.strikeprice +
      ', ' +
      data?.price +
      ', ' +
      (data?.booster_discount_price || 0) +
      ', ' +
      'NA';
    const conversionParam =
      data?.price +
      ', ' +
      data?.delivery +
      ', ' +
      (data?.price + data?.delivery);
    fireEvent({
      category: 'clicked_card_in_pdp',
      id: productData?.id,
      section_name: 'save_more_with_combos',
      card_id: data?.id,
      name: data?.name,
      selling_price: data?.price,
      pricing_param: pricingParam,
      conversion_param: conversionParam,
    });
  };
  useEffect(() => {
    setCountry(getCountry());
  }, []);

  return (
    <>
      {comboData?.map((data, index) => {
        const { symbol, price } = convertPrice(data.price);
        const { price: strikePrice } = convertPrice(data.strikeprice);
        const savings = data?.savings.split('Save').pop();
        const { price: PriceSaving } = convertPrice(savings);
        const text = data?.savings?.includes('Save') ? 'Save ' : '';
        const productFeatureArray = data?.mappedProductsNicknames;

        return (
          <Link
            href={{
              pathname: data.webUrl,
              query: removeDefaultParams(router.query),
            }}
            passHref
            key={`combocards${index}`}
            locale={false}
            legacyBehavior
          >
            <ComboCardContainer single={comboData.length === 1}>
              <ComboCard
                userType={userTypeA}
                isUAE={country === uaeString}
                single={comboData.length === 1}
                id={
                  index == 0
                    ? 'first'
                    : index == comboData.length - 1
                      ? 'last'
                      : `saveComboCards${index}`
                }
                onClick={() => {
                  cardClickHandler(data);
                }}
              >
                {userTypeA ? (
                  <>
                    <div className="flexSection">
                      <div className="leftSection">
                        <Image
                          src={data?.image}
                          alt={data?.name}
                          // sizes="33vw"
                          width={78}
                          height={78}
                          quality={90}
                          loading="lazy"
                        />
                      </div>
                      <div className="rightSection">
                        <ProductName userType={userTypeA}>
                          {data.name}
                        </ProductName>

                        <ul>
                          {productFeatureArray?.map((element, index) => {
                            return <li key={`list_${index}`}>{element}</li>;
                          })}
                        </ul>
                      </div>
                    </div>
                    <ProductPrice>
                      <SaveSticker userType={userTypeA}>
                        {text}
                        {symbol}
                        {PriceSaving}
                      </SaveSticker>
                      <TotalAmount card>
                        <strong>{symbol}</strong>
                        <span>{price}</span>
                      </TotalAmount>
                      <StrikePrice
                        className="span"
                        isUAE={country === uaeString}
                      >
                        <span>
                          {symbol}
                          {strikePrice}
                        </span>
                      </StrikePrice>

                      <Discount className="span">
                        <span> {data.discount}</span>
                      </Discount>
                    </ProductPrice>
                  </>
                ) : (
                  <>
                    <div className="leftSection">
                      <Image
                        src={data?.image}
                        alt={data?.name}
                        // sizes="33vw"
                        width={78}
                        height={78}
                        quality={90}
                        loading="lazy"
                      />
                    </div>
                    <div className="rightSection">
                      <SaveSticker>
                        {text}
                        {symbol}
                        {PriceSaving}
                      </SaveSticker>
                      <ProductName userType={userTypeA}>
                        {data.name}
                      </ProductName>
                      <ProductPrice>
                        <TotalAmount card>
                          <strong>{symbol}</strong>
                          <span>{price}</span>
                        </TotalAmount>
                        <StrikePrice
                          className="span"
                          isUAE={country === uaeString}
                        >
                          <span>
                            {symbol}
                            {strikePrice}
                          </span>
                        </StrikePrice>

                        <Discount className="span">
                          <span> {data.discount}</span>
                        </Discount>
                      </ProductPrice>
                    </div>
                  </>
                )}
              </ComboCard>
            </ComboCardContainer>
          </Link>
        );
      })}
    </>
  );
}
